export const company = {
  productName: 'Operax',
  domain: 'operax.digital',
  legalName: 'CASTOR CONSULTORIA E DESENVOLVIMENTO LTDA - ME',
  cnpj: '41.769.835/0001-98',
  street: 'Rua Goiabal, 81, Apto 201',
  neighborhood: 'Centro Sul',
  city: 'Timóteo',
  state: 'MG',
  zipCode: '35180-970',
  fullAddress: 'Rua Goiabal, 81, Apto 201, Centro Sul, Timóteo/MG, CEP 35180-970',
  email: 'contato@operax.digital',
  /** WhatsApp / telefone comercial e suporte */
  phoneDisplay: '(11) 95502-2990',
  phoneE164Digits: '5511955022990',
  phoneTelHref: 'tel:+5511955022990',
  whatsappHref: 'https://wa.me/5511955022990',
  activity: 'Consultoria em tecnologia da informação',
  jurisdiction: 'Comarca de Timóteo/MG',
  appUrl: 'https://app.operax.digital',
  businessHours: 'Segunda a sexta, das 9h às 18h (horário de Brasília)',
} as const;

/** Link do WhatsApp com texto pré-preenchido (dúvidas de planos, etc.). */
export function whatsappAskHref(message: string): string {
  return `https://wa.me/${company.phoneE164Digits}?text=${encodeURIComponent(message)}`;
}

export const legalFooterText =
  `Operax é operado por ${company.legalName}, CNPJ ${company.cnpj}.`;

export const legalRoutes = {
  privacy: '/politica-de-privacidade',
  terms: '/termos-de-uso',
  dataDeletion: '/exclusao-de-dados',
  contact: '/contato',
} as const;
